import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/ameliyatsiz-yuz-germe-islemlerinin-etkinligi/page.tsx");
